import { render, staticRenderFns } from "./MSearchModel.vue?vue&type=template&id=f5835f9c&"
import script from "./MSearchModel.vue?vue&type=script&lang=js&"
export * from "./MSearchModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports